import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import BuyInvoiceStatusBar, { BuyInvoiceStatusBarNew, CreateInvoiceStatusBarProps } from '../../../BuyInvoiceStatusBar'
import BuyInvoiceFinishedStepButtons, { BuyInvoiceFinishedStepButtonsNew } from '../BuyInvoiceFinishedStepButtons'

type BuyInvoiceFinishedStepHeaderProps = & CreateInvoiceStatusBarProps & OrderStepButtonsBaseComponentProps

const BuyInvoiceFinishedStepHeaderDecider: React.FC<BuyInvoiceFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={BuyInvoiceFinishedStepHeaderDefault} NewComponent={BuyInvoiceFinishedStepHeaderNew} {...rest} />
    )
}

const BuyInvoiceFinishedStepHeaderDefault: React.FC<BuyInvoiceFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <BuyInvoiceStatusBar {...rest} />
            <BuyInvoiceFinishedStepButtons {...rest} />
        </div>
    )
}

const BuyInvoiceFinishedStepHeaderNew: React.FC<BuyInvoiceFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <BuyInvoiceStatusBarNew {...rest} />
            <BuyInvoiceFinishedStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default BuyInvoiceFinishedStepHeaderDecider